export default {
  position: "top-center",
  style: {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "black",
    fontFamily: "Menlo, monospace",
    fontSize: "14px",
    textAlign: "center",
    zIndex: 9999,
  },
  closeStyle: {
    color: "black",
    fontSize: "16px",
  },
};
